import React from 'react'
import { getHTML, getRichText } from '../../core'

import './text-content.scss'

const TextContent = ({ data = {} }) => {
  const { useFullWidthImages } = data

  return <div className='_text-content' data-full-width={useFullWidthImages}>
    <div className="_text-content-inner">
      {data.body && (
        <div 
          className="_text-content-body"
          dangerouslySetInnerHTML={getHTML(data.body)} 
        />
      )}
      {data.content && (
        <div className="_text-content-body">
          {getRichText(data.content)}
        </div>
      )}
      {data.button && (
        <a className="_text-content-button" href={data.button.link}>
          <button>
            {data.button.text}
          </button>
        </a>
      )}
    </div>
  </div>
}

export default TextContent